var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full pt-5"},[_c('div',{staticClass:"flex w-full mt-1"},[_c('h1',{staticClass:"text-xl text-left font-extrabold pl-4 mr-8"},[_vm._v(" Performance Appraisals ")]),_c('Breadcrumb',{attrs:{"items":_vm.breadcrumbs}})],1),[_c('div',{staticClass:"w-full p-5 flex mt-1 flex-col"},[_c('MyAppraisals')],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }